import { useEffect, useState } from "react";
import {isBrowser} from "utils/nookies/utils";
import {permissionLocationAction} from "../libs/logging/helpers/loggingActions";
import {EnumActionNameLevel3} from "../libs/logging/types/loggingTypes";

const useLocationPermission = (): void => {
    useEffect(() => {
        let isFirstTime = !sessionStorage.getItem('geolocationPermission');
        if (isBrowser() && typeof navigator !== 'undefined' && typeof navigator?.permissions !== 'undefined' && navigator?.geolocation && isFirstTime) {
            isBrowser() && navigator?.permissions?.query({ name: 'geolocation' }).then((PermissionStatus) => {
                if (PermissionStatus.state === 'granted' || PermissionStatus.state === 'denied') {
                    sessionStorage.setItem('geolocationPermission', PermissionStatus.state);
                }

                if (PermissionStatus.state === 'prompt') {
                    navigator?.geolocation?.getCurrentPosition(
                        (position) => {
                            permissionLocationAction({ actionNameLvl3: EnumActionNameLevel3.ALLOW });
                            sessionStorage.setItem('geolocationPermission', 'granted');
                        },
                        (error) => {
                            if (error.code === error.PERMISSION_DENIED && PermissionStatus.state !== 'prompt') {
                                permissionLocationAction({ actionNameLvl3: EnumActionNameLevel3.DENY });
                                sessionStorage.setItem('geolocationPermission', 'denied');
                            }
                        }
                    );
                }
            });
        }
    }, []);
};

export default useLocationPermission;
